export const isFetchedPlanner = state => state.eventPlanner.fetched;
export const getEventPlannerData = state => state.eventPlanner.data;
export const hasPlanner = state =>
  state.eventPlanner.data !== null && state.eventPlanner.data.id !== undefined;
